import { useRouter } from 'next/router';
import { useRecoilValue } from 'recoil';
import { withTheme } from 'styled-components';
import { getPageAnimationVariants } from '@/helpers';
import Highlighted from '@/components/Highlighted';
import CloseIcon from '@/components/icons/Close';
import { pageFlow, positionStart, windowSize } from '@/recoil/atoms';
import {
  SAbout,
  SSection,
  SHeader,
  SPageTitle,
  SMain,
  SMainTitle,
  SMainContent,
} from './styles';

const About = () => {
  const router = useRouter();
  const screenSize = useRecoilValue(windowSize);
  const boundingClientRect = useRecoilValue(positionStart);
  const flow = useRecoilValue(pageFlow);
  const { origin } = flow;

  const handleClose = () => {
    router.push('/');
  };

  const items = [
    {
      title: 'Precise and pragmatic,',
      renderContent: () => (
        <p>
          I know exactly what I&apos;m doing and why I&apos;m doing it. My aim
          is to offer optimised solutions providing an optimal user experience,
          whatever the browser, whatever the resolution. I pay{' '}
          <Highlighted light>great attention to detail</Highlighted> and love
          pretty things, but I will always give priority to performance rather
          than creative frenzy.
        </p>
      ),
    },
    {
      title: 'I am eager to learn and grow,',
      renderContent: () => (
        <p>
          Self-taught, I pick things up pretty quickly and{' '}
          <Highlighted light> I&apos;m looking for the next step</Highlighted>
          in my career, within a company willing to make the most of my
          potential on challenging projects. React, GraphQL, Apollo and D3, are
          the kind of thing I would like to keep using in my next position.
        </p>
      ),
    },
    {
      title: "Because it's not just all about coding,",
      renderContent: () => (
        <p>
          and as I am definitely client-oriented, I developed a general
          understanding of the core UI principles, and keep learning about
          <Highlighted light>interaction and motion design</Highlighted> to push
          the user experience as far as possible. I care about{' '}
          <Highlighted light>
            semantics, accessibility and I know my SEO basics!
          </Highlighted>
        </p>
      ),
    },
    {
      title: 'I am not just a girly geek,',
      renderContent: () => (
        <p>
          I love other things like hiking, running, reading, exploring cities
          and the country side, listening to rock and electronic music, and I
          can&apos;t say no to a Sunday Roast!
        </p>
      ),
    },
  ];

  return (
    <SAbout
      data-testid="route-about"
      initial="start"
      animate="end"
      exit="exit"
      variants={getPageAnimationVariants(flow, screenSize, boundingClientRect)}
      transition={{ duration: 0.1 }}
    >
      <SHeader data-testid="about-header">
        <CloseIcon
          alt={`Back to ${origin ? origin : 'home'}`}
          handleClose={handleClose}
          mode="dark"
        />
        <SPageTitle>A bit more about me</SPageTitle>
        <p>
          Originally from France, I have been in London for 10 years. In case
          you are wondering, I am here for the long run.
        </p>
      </SHeader>
      <SMain>
        {items.map((item) => (
          <SSection data-testid="section-about" key={item.title}>
            <SMainTitle>{item.title}</SMainTitle>
            <SMainContent>{item.renderContent()}</SMainContent>
          </SSection>
        ))}
      </SMain>
    </SAbout>
  );
};

export default withTheme(About);
